import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import { AuthProvider, useAuth } from './hooks/useAuth'
import { supabase } from './lib/supabase'
import Sidebar from './components/Sidebar'
import Login from './pages/Login'
import Generator from './pages/Generator'
import Reports from './pages/Reports'
import SettingsClients from './pages/settings/Clients'
import SettingsTeam from './pages/settings/Team'
import { useIsMobile } from './hooks/useIsMobile'

function Integrations() {
  return (
    <div style={{ padding: 28, fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif", overflowY: 'auto', height: '100%' }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', margin: '0 0 20px' }}>Integrazioni</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 500 }}>
        {[
          { name: 'Google Ads', status: '✅ Connesso', color: '#22c55e' },
          { name: 'Meta Ads', status: '⏳ App Review in corso', color: '#f59e0b' },
          { name: 'TikTok Ads', status: '⏳ App Review in corso', color: '#f59e0b' },
        ].map(i => (
          <div key={i.name} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--text)' }}>{i.name}</span>
            <span style={{ fontSize: 12, color: i.color }}>{i.status}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const isMobile = useIsMobile()

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--bg)', position: 'relative' }}>

      {/* Sidebar — su mobile è un drawer overlay */}
      {isMobile && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 40 }}
        />
      )}
      <div style={{
        position: isMobile ? 'fixed' : 'relative',
        left: isMobile ? (sidebarOpen ? 0 : -220) : 0,
        top: 0, bottom: 0, zIndex: 50,
        transition: isMobile ? 'left 0.25s ease' : 'none',
      }}>
        <Sidebar onClose={() => setSidebarOpen(false)} isMobile={isMobile} />
      </div>

      {/* Area contenuto */}
      <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', minWidth: 0 }}>

        {/* Top bar mobile */}
        {isMobile && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
            background: 'var(--sidebar-bg)', borderBottom: '1px solid var(--border)',
            position: 'sticky', top: 0, zIndex: 30, flexShrink: 0,
          }}>
            <button
              onClick={() => setSidebarOpen(true)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text)', padding: 4, display: 'flex', alignItems: 'center' }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <line x1="3" y1="6" x2="17" y2="6"/>
                <line x1="3" y1="10" x2="17" y2="10"/>
                <line x1="3" y1="14" x2="17" y2="14"/>
              </svg>
            </button>
            <div style={{ width: 24, height: 24, background: '#7c3aed', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: 'white' }}>G</div>
            <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)' }}>Gallicantus</span>
          </div>
        )}

        <Outlet />
      </div>
    </div>
  )
}

function Spinner() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: 'var(--text3)', fontSize: 13, fontFamily: 'monospace' }}>Caricamento...</div>
    </div>
  )
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <Spinner />
  if (!user) return <Navigate to="/login" replace />
  return children
}

function AppWithData() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route index element={<Generator />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings/clients" element={<SettingsClients />} />
          <Route path="settings/integrations" element={<Integrations />} />
          <Route path="settings/team" element={<SettingsTeam />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppWithData />
      </AuthProvider>
    </ThemeProvider>
  )
}
